module.exports = __webpack_public_path__ + "img/plane-small.74ac6798.png";